import { useEffect, useRef } from 'react';
import LinesEllipsis from 'react-lines-ellipsis';
import { observer } from 'mobx-react';

export interface TextTruncateProps {
    text: string;
    maxLine?: number;
    additionalClassName?: string;
    splitByLetters?: boolean;
    onTruncate?: (isTruncated: boolean) => void;
    setClamped?: (isClamped: boolean) => void;
}

interface Props extends TextTruncateProps {}

export const TextTruncate = observer(
    ({ text, maxLine = 3, splitByLetters = false, additionalClassName, onTruncate, setClamped }: Props) => {
        const ref = useRef<any>(null);

        useEffect(() => {
            if (ref?.current) {
                setClamped?.(ref.current.clamped);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [ref]);

        const onReflow = ({ clamped }: { clamped: boolean; text: string }) => {
            onTruncate?.(clamped);
        };

        return (
            <LinesEllipsis
                ref={ref}
                className={additionalClassName}
                text={text ? `${text}` : ''}
                maxLine={maxLine}
                basedOn={splitByLetters ? 'letters' : 'words'}
                onReflow={onTruncate ? onReflow : undefined}
            />
        );
    },
);
